<template>
  <!-- 搜索联系人结果 -->
  <div class="bg-white z-index-1 left-0 bottom-0 right-0">
    <div class="m-t-10 m-l-10 m-b-5 m-r-12 f-s-12 flex justify-content-between align-items-center" style="color: #999;">
      <div>最近搜索</div>
      <div class="flex align-items-center cursor-pointer" @mousedown.prevent="clearSearchHistory">
        <img src="@/assets/images/im/delete@2x.png" style="width: 16px;height:17px" class="d-block"/>
        <span class="d-block m-l-5">清空</span>
      </div>
    </div>
    <div class="flex" style="flex-wrap: wrap;">
      <div class="h-25 p-l-10 m-t-10 o-hidden t-o-ellipsis w-s-nowrap p-r-10 f-s-12 cursor-pointer" style="max-width: 94%;margin-left: 3%;margin-right: 3%;line-height: 25px;color:#999999;background: #eaeaea;border-radius: 13px;" v-for="(item,index) in searchHistory" v-if="index<20" :key="index" @mousedown="searchNearestHistory(item)">
          {{item}}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    im: {
      type: Object,
      default: function () {
        return {}
      }
    },
    width: {
      type: Number,
      default: 250
    },
    navSelctType:{
      type: String,
      default: "0"
    }
  },
  data: function () {
    return {
      listWidth: 185,
      searchHistory: []
    };
  },
  components: {
    
  },
  created: function () {
    
  },
  mounted:function () {
    this.getSearchHistory();
  },
  computed: {
   
  },
  methods: {
    getSearchHistory:function(){
      let searchHistory = localStorage.getItem("searchKeyWord") || "";
      if(searchHistory){
        this.searchHistory = searchHistory.split(",").reverse()
      }
    },
    clearSearchHistory:function(){
      localStorage.removeItem("searchKeyWord");
      this.searchHistory = [];
      this.$emit("clearSearchHistoryState")
    },
    searchNearestHistory:function(item){
      this.$emit("searchNearestHistory",item)
    },
  },
  watch: {
    
  }
}
</script>